/**
 * @name OfftakeEntriesService
 * @author Surjeet Bhadauriya <surjeet.bhadauriya@techifysolutions.com>
 * @description All APIs for offtake entry
 * @version 0.0.1
 */
import { request } from "./Request";
import { routes } from "../constants/constant.route";

const {
  GET_DEALER_NAME,
  GET_SUBSIDAIRY,
  GET_OFFTAKE_BY_ID,
  GET_OFFTAKE_ENTRIES_COUNT,
  GET_OFFTAKE_ENTRY,
  GET_VEHICLE_SKU_ID,
  UPLOAD_INVOICE,
  ADD_OFFTAKE_ENTRY,
  UPDATE_OFFTAKE_ENRY
} = routes.OFFTAKE_ENTRY;
const API_URL = process.env.VITE_APP_API_URL;

export default class OfftakeEntryService {
  /**
   * @name getDealerName
   * @description Get Dealer Data
   * @param {query: String}
   * @method GET
   * @returns promise
   */
  static getDealerName(fleetId) {
    if (fleetId) {
      return request(
        "GET",
        `${API_URL}${GET_DEALER_NAME}?u=${fleetId}`,
        null,
        null,
        null
      );
    }
    return request("GET", `${API_URL}${GET_DEALER_NAME}`, null, null, null);
  }

  /**
   * @name getOfftakeEntries
   * @description getOfftakeEntries
   * @param {flag: Boolean}
   * @method GET
   * @returns promise
   */
  static getOfftakeEntries(flag, uuid, year) {
    let qp = `download_report=${flag}`;
    if (uuid) {
      qp += `&u=${uuid}`;
    }
    if (year) {
      qp += `&y=${year}`;
    }
    return request(
      "GET",
      `${API_URL}${GET_OFFTAKE_ENTRY}?${qp}`,
      null,
      null,
      null
    );
  }

  /**
   * @name getOfftakeEntryById
   * @description getOfftakeEntryById
   * @param {data: Object}
   * @method POST
   * @returns promise
   */
  static getOfftakeEntryById(data) {
    return request("POST", `${API_URL}${GET_OFFTAKE_BY_ID}`, null, data, null);
  }

  /**
   * @name getOfftakeEntriesCount
   * @description getOfftakeEntriesCount
   * @param {}
   * @method GET
   * @returns promise
   */
  static getOfftakeEntriesCount(uuid, year) {
    let qp = ``;
    if (uuid) {
      qp += `?u=${uuid}`;
    }
    if (year && uuid) {
      qp += `&y=${year}`;
    } else if (year && !uuid) {
      qp += `?y=${year}`;
    }

    return request(
      "GET",
      `${API_URL}${GET_OFFTAKE_ENTRIES_COUNT}${qp}`,
      null,
      null,
      null
    );
  }

  /**
   * @name getSubsadairy
   * @description Get Subsadairy Data
   * @param {}
   * @method GET
   * @returns promise
   */
  static getSubsadairy(fleetId) {
    if (fleetId) {
      return request(
        "GET",
        `${API_URL}${GET_SUBSIDAIRY}?all=true&id=${fleetId}`,
        null,
        null,
        null
      );
    }
    return request(
      "GET",
      `${API_URL}${GET_SUBSIDAIRY}?all=true`,
      null,
      null,
      null
    );
  }

  /**
   * @name getSKUID
   * @description getSKUID
   * @param {query: Object}
   * @method GET
   * @returns promise
   */
  static getSKUID(query) {
    return request(
      "GET",
      `${API_URL}${GET_VEHICLE_SKU_ID}?vehicle_type=${query.type}&searchquery=${query.name}`,
      null,
      null,
      null
    );
  }

  /**
   * @name uploadInvoice
   * @description Upload invoice
   * @param {file: formData}
   * @method POST
   * @returns promise
   */
  static uploadInvoice(file) {
    return request(
      "POST",
      `${API_URL}${UPLOAD_INVOICE}`,
      null,
      file,
      {
        "content-type": "multipart/form-data"
      }
    );
  }

  /**
   * @name addOfftakeEntry
   * @description Add offtake entry
   * @param {data: Object}
   * @method POST
   * @returns promise
   */
  static addOfftakeEntry(data) {
    return request("POST", `${API_URL}${ADD_OFFTAKE_ENTRY}`, null, data, null);
  }

  /**
   * @name updateOfftakeEntry
   * @description Update offtake entry
   * @param {data: Object}
   * @method POST
   * @returns promise
   */
  static updateOfftakeEntry(data) {
    return request(
      "POST",
      `${API_URL}${UPDATE_OFFTAKE_ENRY}`,
      null,
      data,
      null
    );
  }
}
